import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  { title: "ID", dataIndex: "id", key: "id", fixed: "left", width: 150 },
  { title: "Nome", dataIndex: "name", key: "name", ellipsis: true, width: 200 },
];

export default function AbsenceTypes() {
  return <SimpleTablePage resource="absenceType" columns={columns} />;
}
